/* eslint-disable react/jsx-sort-props */
// *https://www.registers.service.gov.uk/registers/country/use-the-api*
import React from "react";
import { TextField, CircularProgress } from "@mui/material";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import http from "../../services/httpService";
import { search } from "../../services/generalService";

let x = 0;
export default function AMAutoSearch({
  name,
  value: val,
  loadOnce: loadOnceProp,
  onChange,
  autoFocus,
  error,
  helperText,
  placeholder,
  label,
  variant,
  anotherCriteria,
  ...rest
}) {
  x++;
  console.log("val", val);
  console.log(name, `rendered ${x}times`);
  const [open, setOpen] = React.useState(false);
  const [justLoadedById, setJustLoadedById] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const loadFirstTime = open && (options.length === 0 || justLoadedById); // Standered from demo
  const [loadingFromServer, setLoadingFromServer] = React.useState(false);

  //= ========Create Filter Options=======================
  // this is optional you can use   <Autocomplete> without it ,but you will not be able to use <Autocomplete filterOptions=...>
  const filter = createFilterOptions({
    // matchFrom: 'start', ///To EnhancePerformance ** It make filter startsWith instead of contains
    limit: 500, // To EnhancePerformance  ** It makes the maximam rendered options even thou source have more items
    // ignoreAccents: false, //To EnhancePerformance
    stringify: (option) => `${option.textField} ${option.searchField}`,
  });
  //= ========END Create Filter Options=========================
  const handleSelectedIndexChange = (event, value, reason) => {
    console.log("handleSelectedIndexChange Line 41", value);
    onChange(event, value, reason, name);
    console.log("handleSelectedIndexChange Line 43", value);
  };

  const handleSetOptions = async (specificId) => {
    const { lookupId, formId, reportId } = rest;
    //anotherCriteria.: CountryId=#state.countryId
    const c = !specificId
      ? anotherCriteria
      : `${anotherCriteria}  and id=${specificId}`;
    const { data } = await search(lookupId, formId, reportId, c);
    if (!data) return;
    const newOptions = data.map((option) => ({
      valueField: option.ID,
      textField: option.name,
      searchField: option.searchField,
      ...option,
    }));
    pushOptions(newOptions);
  };

  const pushOptions = (newOptions) => {
    let allOptions = [...options];
    if (allOptions.length > 0) {
      newOptions.map((newItem) => {
        if (
          !allOptions.some((option) => option.valueField === newItem.valueField)
        ) {
          allOptions.push(newItem);
        }
      });
    } else {
      allOptions = [...allOptions, ...newOptions];
    }
    setOptions(allOptions);
  };

  const LoadDataFromServer = async (active, specificId) => {
    if (loadingFromServer) {
      return undefined;
    }
    setLoadingFromServer(true);
    if (active) {
      await handleSetOptions(specificId);

      setJustLoadedById(!!specificId);
      setLoadingFromServer(false);
    }
  };

  React.useEffect(() => {
    const { lookupId, formId, reportId } = rest;
    if (loadFirstTime && lookupId && (formId || reportId)) {
      console.log("useEffect []);");
      let active = true;
      LoadDataFromServer(active);
      return () => {
        active = false;
      };
    }
  }, [loadFirstTime, rest.lookupId]);

  React.useEffect(() => {
    const { lookupId, formId, reportId } = rest;
    if (val && lookupId && (formId || reportId)) {
      if (options.find((x) => x.valueField == val) !== undefined) return;

      let active = true;
      LoadDataFromServer(active, val);
      return () => {
        active = false;
      };
    }
  }, [val]);

  const getValueObject = () => {
    if (val.toString().trim() === "") return null;
    if (options && options.length) {
      const selectedObj = options.find((x) => x.valueField == val);
      return selectedObj || val;
    } else return val;
  };
  return (
    <Autocomplete
      id={name}
      nbame={name}
      size="small"
      // fullWidth
      disabled={rest.disabled}
      open={open}
      loading={loadingFromServer}
      // Events
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      // onChange={props.onChange}//this way can't work because the eventTarget refers to [option] , so we can't get name from it
      onChange={handleSelectedIndexChange}
      value={getValueObject()}
      // getOptionSelected={(option, value) => {
      //   //TO highlit selected option in drop menue
      //   return option['valueField'] === value
      // }}
      getOptionLabel={(option) =>
        option.textField ? option.textField : option.toString()
      }
      filterOptions={(options, params) => {
        if (params.inputValue) {
          params.inputValue = params.inputValue.trim();
        }
        const filtered = filter(options, params);

        // #region FilteredIds It Will be used in new reload request
        // const newFilteredIds = filtered.map((item) => item.valueField);
        //console.log("newFilteredIds", newFilteredIds);
        // if (
        //   JSON.stringify(filteredIds.sort()) !==
        //   JSON.stringify(newFilteredIds.sort())
        // ) {
        //   setFilteredIds(newFilteredIds);
        // }
        // #endregion

        // if (params.inputValue !== "") {
        //   if (filtered.length < 10) {
        //     if (params.inputValue !== loadMoreText) {
        //       setloadMoreText(params.inputValue);
        //     }
        //   }
        // }

        // if (!loadOnce) {
        //   filtered.push({
        //     loadAllData: true,
        //     valueField: "loadall",
        //     textField: "--Load All--",
        //   });
        // }

        // filtered.push({
        //   valueField: 's',
        //   textField: '--Advanced Search--'
        // });

        return filtered;
      }}
      options={options}
      renderInput={(params) => (
        <TextField
          {...params}
          autoFocus={autoFocus}
          error={error}
          margin="dense"
          fullWidth
          helperText={helperText}
          placeholder={placeholder}
          // style={{ height: 30 }}

          // // TODO : Apply this style only if language is arabic
          // InputLabelProps={{
          //   style: {
          //     fontWeight: 'bold',
          //     // fontSize: 17
          //   }
          // }}

          //onChange={handleTextChange}
          label={label}
          variant={variant || "outlined"}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loadingFromServer ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
                {/* <Button style={{ padding: 0, width: 20, minWidth: 20 }}>ِA.S</Button> */}
              </>
            ),
          }}
        />
      )}
    />
  );
}
